module.exports = __webpack_public_path__ + "img/notification-warning.52e52d2b.svg";